import Splide from '@splidejs/splide'
import isEqual from "lodash/isEqual"
import isEmpty from "lodash/isEmpty"

export default class Gallery {
	constructor() {
		this.getDomElements()

		if (!this.dom.slider || !this.dom.main || !this.dom.count || !this.dom.thumbnails.length || !this.dom.zoom) return

		this.active = 0
		this.currentMediaId = 0
		this.zoomStatus = false

		this.init()
	}

	init() {
		this.currentMediaId = this.dom.main.dataset.id

		this.slider()
		this.buildVariationVariables()
		this.handleChange()
	}

	getDomElements() {
		this.dom = {
			slider: document.querySelector('.js-gallery-slider'),
			main: document.querySelector('.js-gallery-main'),
			zoom: document.querySelector('.js-gallery-zoom'),
			count: document.querySelector('.js-gallery-count'),
			thumbnails: document.querySelectorAll('.js-gallery-thumbnails'),
			variations: document.querySelector('.variations_form'),
			variationSelects: document.querySelectorAll('.variations select'),
		}
	}

	slider() {
		this.gallerySlider = new Splide(this.dom.slider, {
			type: 'slide',
			easing: 'cubic-bezier(.77,0,.175,1)',
			speed: 500,
			arrows: true,
			pagination: false,
			keyboard: false,
			drag: false,
			snap: true,
			perPage: 1,
			perMove: 1,
			heightRatio: 1,
			direction: 'ttb'
		}).mount()
	}

	handleChange() {
		this.handleClickThumbnails()
		this.handleChangeImage()
		this.handleSliderChange()
		this.setCounter()
		this.handleVariationsChange()
		this.handleZoom()
	}

	handleClickThumbnails() {
		this.dom.thumbnails.forEach((thumb) => {
			thumb.addEventListener('click', () => {
				const id = thumb.dataset.id;
				const index = thumb.dataset.index;

				if (thumb.dataset.id === this.currentMediaId) return

                this.currentMediaId = id

				this.handleThumbnailChange()

				this.active = index

                this.changeActiveSlide()
			})
		});
	}

	handleThumbnailChange() {
		let current = this.dom.slider.querySelector(`.js-gallery-thumbnails[data-index="${this.active}"]`)
		current.classList.remove('isActive')

		this.dom.zoom.classList.remove('isZoom')
		this.zoomStatus = false

		this.handleChangeImage()
	}

	handleChangeImage() {
		let newElement = this.dom.slider.querySelector(`.js-gallery-thumbnails[data-id="${this.currentMediaId}"]`)
		let newImage = newElement.dataset.large

		newElement.classList.add('isActive')
		this.dom.main.src = newImage
		this.dom.zoom.style.backgroundImage = `url(${newImage})`
	}

	handleSliderChange() {
		this.gallerySlider.on('move', (newIndex, prevIndex) => {
			let newElement = this.dom.slider.querySelector(`.js-gallery-thumbnails[data-index="${newIndex}"]`)

			this.currentMediaId = newElement.dataset.id

			this.handleThumbnailChange()

			this.active = newIndex

			this.setCounter()
		})
	}

	handleVariationsChange() {
		if (!this.dom.variations || !this.dom.variationSelects.length) return

		this.dom.variationSelects.forEach((select) => {
            select.addEventListener('change', () => {
				this.setVariationValues()
			})
		})
	}

  handleVariationImages() {
    const variationData = JSON.parse(this.dom.variations.dataset.product_variations)
		let activeVariation = {}

		if (variationData && variationData.length) {
			variationData.forEach((variation) => {
				if (isEqual(this.variations, variation.attributes)) {
					
					console.log(_);
					activeVariation = variation
				}
			})
		}

		if (isEmpty(activeVariation)) return


		const newIndex = this.dom.slider.querySelector(`.js-gallery-thumbnails[data-id="${activeVariation.image_id}"]`)

		if (newIndex) {
			this.currentMediaId = activeVariation.image_id
			this.handleThumbnailChange()
			this.active = newIndex.dataset.index
			this.changeActiveSlide()
		}
  }

	handleZoom() {
		this.dom.zoom.addEventListener('click', () => {
			this.zoomStatus = !this.zoomStatus
			this.dom.zoom.classList.toggle('isZoom')

			if (this.zoomStatus === true) this.triggerZoom();
		})
	}

    setCounter() {
        // Animate
        this.dom.count.textContent = parseInt(this.active) + 1
    }

	changeActiveSlide() {
		this.gallerySlider.go(parseInt(this.active))
		this.setCounter()
	}

    buildVariationVariables() {
        if (!this.dom.variations || !this.dom.variationSelects.length) return

		this.variations = {}

		this.setVariationValues()
	}

    setVariationValues() {
        this.dom.variationSelects.forEach((select) => {
            this.variations[select.name] = select.value
        })

        this.handleVariationImages()
    }

	triggerZoom() {
		if (this.dom.zoom && this.zoomStatus) {
			this.dom.zoom.addEventListener('mousemove', (e) => {
				var zoomer = e.currentTarget;
				var offsetX = 0;
				var offsetY = 0;
				var x = 0;
				var y = 0;

				e.offsetX ? offsetX = e.offsetX : offsetX = e.touches.length ? e.touches[0].pageX : 0
				e.offsetY ? offsetY = e.offsetY : offsetX = e.touches.length ? e.touches[0].pageX : 0
				x = offsetX/zoomer.offsetWidth*100
				y = offsetY/zoomer.offsetHeight*100
				zoomer.style.backgroundPosition = x + '% ' + y + '%';
			});
		}
	}
}
